import React from 'react'
import { connect } from 'react-redux'
import { successMessage } from 'lib/flash-message'
// @ts-ignore
import { track, useTracking } from '../../../lib/analytics'
import { openQuickViewModal } from '../../../registry/modals/actions'
import { InfoButton } from '../../../components/buttons'
import AddToCartButton from '../../../store/components/add-to-cart-button'

export interface ProductProps {
  productId: number
  title: string
  optionsCta?: string | null
}

export interface ProductCardActionProps {
  originalCartSubTotal?: number | null
  product: ProductProps
  openModal(productId: number, onAddtoCartSuccess: any): any
}

export function ProductCardAction({
  originalCartSubTotal,
  product,
  openModal,
}: ProductCardActionProps) {
  const { productId, optionsCta, title } = product
  const tracker = useTracking()

  const handleTrackAddToCart = () => {
    tracker.trackEvent({
      event: track.carouselProductAddedToCart,
      originalCartTotal: originalCartSubTotal,
      eventLocation: optionsCta
        ? track.EventLocation.CART_MINUS_RECOMMENDATIONS_QUICK_VIEW_MODAL
        : track.EventLocation.CART_MINUS_RECOMMENDATIONS_CAROUSEL,
    })
  }

  if (optionsCta) {
    return (
      <InfoButton
        onClick={(e: any) => {
          e.preventDefault()
          openModal(productId, handleTrackAddToCart)
        }}
        pill
      >
        Add to Cart
      </InfoButton>
    )
  }
  return (
    <AddToCartButton
      productId={productId}
      quantity={1}
      useInfoButtonStyle
      buttonStyle={{ pill: true, block: false }}
      style={undefined}
      onSuccess={() => {
        handleTrackAddToCart()
        successMessage(`${title} added to cart!`)
      }}
    />
  )
}

const mapDispatchToProps = (dispatch: any) => ({
  openModal: (productId: number, onAddtoCartSuccess: void) =>
    dispatch(openQuickViewModal(productId, onAddtoCartSuccess)),
})

export default connect(undefined, mapDispatchToProps)(ProductCardAction)
